/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        // Clean up success alerts for forms that were not the one submitted
        const hash = window.location.hash;
        const submittedFormId = hash && hash.startsWith('#') ? hash.substring(1) : null;
        if (submittedFormId) {
          document.querySelectorAll('form').forEach(form => {
            if (form.id !== submittedFormId) {
              form.querySelectorAll('.alert.bg-success-bg, [id$="-success"]').forEach(alert => alert.remove());
            }
          });
        }

        const form = this.querySelector('form');
        const isCurrentFormSubmitted = form && submittedFormId === form.id;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (isCurrentFormSubmitted && this.querySelector('.alert')) {
          this.open();
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          } else if (this.dataset.trigger === 'clipboard') {
            this.copyHandler = this.copyHandler || this.handleCopy.bind(this);
            document.addEventListener('copy', this.copyHandler);
          }
        }
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }

        if (this.copyHandler) {
          document.removeEventListener('copy', this.copyHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
      }

      /**
       * Handles 'copy' events on the body.
       */
      handleCopy() {
        if (!getCookie(this.cookie)) this.open();
      }

      /**
       * Handles 'click' events on the modal, overriding the base class to
       * validate any form inside the popup before allowing it to close.
       * @param {object} evt - Event object.
       */
      handleClick(evt) {
        // Backdrop click — delegate to base class as normal.
        if (evt.target === this) {
          super.handleClick(evt);
          return;
        }

        // Only intercept js-close-modal elements.
        if (!evt.target.matches('.js-close-modal')) return;

        // Check whether the clicked element is a submit button inside a form
        // (or is associated with one via the 'form' attribute).
        const form = evt.target.closest('form')
          || (evt.target.getAttribute('form') && document.getElementById(evt.target.getAttribute('form')));

        if (form && !form.checkValidity()) {
          // Keep the popup open and show the browser's native validation UI.
          form.reportValidity();
          return;
        }

        // Form is valid (or not a form-submit button) — close as normal.
        this.close();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        setCookie(this.cookie, true, this.dataset.dismissDays);
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
